import { render, staticRenderFns } from "./TsAmzLibri.vue?vue&type=template&id=11670685&scoped=true"
import script from "./TsAmzLibri.vue?vue&type=script&lang=js"
export * from "./TsAmzLibri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11670685",
  null
  
)

export default component.exports